import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { usePaymentStatus } from '@aibees/shared/hooks/payment/use-payment-status';
import { classnames, fCredit } from '@aibees/shared/utils';
import { Alert } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { CurrentPlanPaymentFailedProps as Props } from './types';

export const CurrentPlanPaymentFailed = memo(({ className }: Props) => {
  const { data } = useCurrentSubscriptionApi();

  const { paymentFailed } = usePaymentStatus();

  if (!paymentFailed) return null;

  return (
    <Styled.Wrapper
      className={classnames('CurrentPlanPaymentFailed', className)}
      sx={SX.root}
    >
      <Alert icon={false} severity="error">
        {`Your remaining ${fCredit(
          data?.credit?.total || 0
        )} credits are on hold. Please settle your outstanding invoice to reactivate your account and receive new credits.`}
      </Alert>
    </Styled.Wrapper>
  );
});

CurrentPlanPaymentFailed.displayName = 'CurrentPlanPaymentFailed';
